
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/ShuffleMaps/Studios",
      function () {
        return require("private-next-pages/ShuffleMaps/Studios.jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/ShuffleMaps/Studios"])
      });
    }
  